<template>
  <b-navbar toggleable="lg" fixed="top">

    <div class="container">

        <a :href="homepageUrl">
          <img class="header__logo-image" src="~assets/img/logo-header.png">
        </a>
        <a href="http://www.ttalliance.com/">
          <img class="header__logo-image header__logo-image--brand" src="~assets/img/logo-transformation-alliance.jpg">
        </a>

    </div>

  </b-navbar>
</template>

<script>
export default {
  data() {
    return {
      homepageUrl: process.env.HOMEPAGE,
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Navbar/Empty.vue